import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import TimezoneSelect from "@Shared/components/inputs/timezone-select.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { sameAsWithLabel, validPassword } from "@Shared/@Utils/validation-rules";
import PasswordInput from "@Shared/components/inputs/password-input.vue";
import { decodeDetailsToken } from "@Client/@Utils/custom";
import { TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PersonalDetailsStep",
  components: {
    MaterialInput,
    PhoneInput,
    PasswordInput,
    TimezoneSelect,
    SimpleButton
  },
  mixins: [validationMixin],
  props: {
    loadingState: {
      type: Object,
      required: true
    }
  },
  validations() {
    return {
      formData: {
        accountType: {
          required
        },
        applicationId: {
          required
        },
        email: {
          required,
          email
        },
        familyName: {
          required
        },
        givenName: {
          required
        },
        password: {
          required,
          validPassword
        },
        passwordRepeat: {
          required,
          sameAs: sameAsWithLabel("Password above")("password")
        },
        phoneNumber: {
          required
        },
        timezone: {
          required
        }
      },
      terms: {
        required(value) {
          return value;
        }
      }
    };
  },
  data() {
    return {
      formData: {
        applicationId: "",
        accountType: "Client",
        currentSubdomain: window.location.pathname.replace("/", ""),
        email: "",
        familyName: "",
        givenName: "",
        middleName: "",
        password: "",
        passwordRepeat: "",
        phoneNumber: "",
        timezone: "",
        isGhost: undefined
      },
      terms: false
    };
  },
  computed: {
    loading() {
      return this.loadingState.creating.loading;
    },
    loadingStatus() {
      return this.loadingState.creating.status;
    },
    TOS_EXTERNAL_LINK() {
      return TOS_EXTERNAL_LINK();
    },
    isFrenchLanguage() {
      return this.$root.$i18n.locale === "fr-CA";
    }
  },
  beforeMount() {
    this.loadInvitation();
  },
  methods: {
    handleSubmit() {
      if (this.$v.$invalid || !this.terms) return;
      this.$emit("submit", this.formData);
    },
    async loadInvitation() {
      const {
        params: paramsToken,
        t: detailsToken
      } = this.$route.query;
      if (!paramsToken && !detailsToken) return;
      const {
        isGhost,
        emailFromShare,
        applicationId,
        givenName,
        familyName,
        phoneNumber,
        locale
      } = await decodeDetailsToken({
        token: detailsToken,
        params: paramsToken
      });
      if (isGhost && emailFromShare) {
        this.formData = _objectSpread(_objectSpread({}, this.formData), {}, {
          isGhost,
          email: emailFromShare,
          applicationId,
          givenName,
          familyName,
          phoneNumber,
          locale
        });
        this.$nextTick(() => {
          this.$v.$touch();
        });
      }
    }
  }
});